import React from 'react'

import { usePlaceType, useTypePermission } from '../_context/PlaceTypeContext'
import FixedRoundButton from '../../../components/actions/FixedRoundButton'
import { useOpenEditPlaceModal } from '../../../utils/routes/modals/modalsActions'

const AddNewButton = () => {
  const type = usePlaceType()
  const hasAddPermission = useTypePermission('create')
  const openModal = useOpenEditPlaceModal()
  if (!hasAddPermission) return false

  return <FixedRoundButton onClick={() => openModal({ initialState: { type } })} />
}

export default AddNewButton
